var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useId } from 'react';
import { Box, Button, MessageBox, Modal, Trans, translate, useToastService, } from '@lucidlink/uicore';
import { ModalActions, ModalDescription, ModalTitle } from '#components';
import { useSetAccessSettings } from '../../../../../../query-hooks/mutations/useSetAccessSettings';
export const RestrictMobileAccessModal = ({ closeModal, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    const { addToast } = useToastService();
    const { mutation: { mutate: setAccessSettings }, } = useSetAccessSettings({ filespaceId, workspaceId }, {
        onSuccess: () => {
            addToast({
                'data-testid': 'success-filespace-restrict-mobile',
                kind: 'positive',
                content: {
                    message: translate('Mobile apps access is now restricted.'),
                },
            });
            closeModal();
        },
        onError: () => {
            addToast({
                'data-testid': 'error-filespace-restrict-mobile',
                kind: 'negative',
                content: {
                    label: translate('Failed to restrict mobile app access'),
                    message: translate('Failed to restrict mobile app access'),
                },
            });
        },
    });
    const restrictAccess = useCallback(() => {
        setAccessSettings({
            settingName: 'restrictMobileAccess',
            settingValue: true,
        });
    }, [setAccessSettings]);
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, "data-testid": "restrict-mobile", children: [_jsxs(Box, { gap: "s", orientation: "vertical", children: [_jsx(ModalTitle, { id: titleId, children: _jsx(Trans, { children: "Are you sure you want to restrict all access on the mobile apps?" }) }), _jsxs(Box, { gap: "l", orientation: "vertical", children: [_jsx(ModalDescription, { children: _jsx(Trans, { children: "The filespace will be inaccessible on the Android and iOS mobile apps by all users, including the workspace owner and admins." }) }), _jsx(MessageBox, { "data-testid": "restrict-mobile-access", type: "informative", children: _jsx(Trans, { children: "After this restriction is applied, all members must use version 3.1 or later to access this filespace from the desktop app." }) })] })] }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "restrict-mobile-access-cancel", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "restrict-mobile-access-confirm", isFullWidth: true, onClick: restrictAccess, size: "big", children: _jsx(Trans, { children: "Yes, restrict" }) })] })] }));
};
_react_refresh_temp_1 = RestrictMobileAccessModal;
$RefreshReg$(_react_refresh_temp_1, "RestrictMobileAccessModal");
_react_refresh_temp_2(RestrictMobileAccessModal, "6MduEP9nA2p/omGguDf3pzYcQvQ=", false, () => [useToastService, useSetAccessSettings]);
